/**
 * Admin storage usage API — R2 usage monitoring.
 */

import { apiGet } from "./client.js";

export interface StorageUsageSummary {
  monthKey: string;
  writes: { count: number; bytes: number };
  reads: { count: number; bytes: number };
  deletes: { count: number; bytes: number };
  totalBytes: number;
  totalOperations: number;
  freeTier: {
    storagePct: number;
    writeOpsPct: number;
    readOpsPct: number;
  };
}

export interface StorageUsageResponse {
  r2Enabled: boolean;
  currentMonth: StorageUsageSummary;
  recentMonths: StorageUsageSummary[];
  totalStorageBytes: number;
  totalStorageMB: number;
  totalStorageGB: number;
  freeTierLimits: {
    storageGB: number;
    writeOpsPerMonth: number;
    readOpsPerMonth: number;
  };
}

export function getStorageUsage(): Promise<StorageUsageResponse> {
  return apiGet<StorageUsageResponse>("/admin/storage-usage");
}
